import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './reportsMessages';

import './Label.scss';

export const colors = ['#0DD396', '#BEE94B', '#0DD396', '#FF836A'];
export const colorsTRI = ['#e57373', '#f06292', '#ba68c8', '#9575cd'];

const Label = (props) => (
  <div
    className="Label"
    style={
      props.isReportTRI || props.isGradeGroupAvgView
        ? { top: '25px', width: '150px' }
        : props.TRILabel
        ? { top: '-45px' }
        : { top: '0', width: '150px' }
    }
  >
    <strong>
      <FormattedMessage {...messages.label} />:
    </strong>
    <div className="container-bars">
      {props.isStudentTRI ? (
        <FormattedMessage {...messages.area} />
      ) : props.isSchoolView || props.isGradeGroupAvgView ? (
        <FormattedMessage {...messages.class} />
      ) : props.isApplicationView ? (
        <FormattedMessage {...messages.schools} />
      ) : (
        <FormattedMessage {...messages.student} />
      )}
      <div className="bars">
        {props.isReportTRI
          ? colorsTRI.map((color, index) => (
              <div className={`bar bar-${index}`} style={{ backgroundColor: color }} />
            ))
          : colors.map((color, index) => (
              <div className={`bar bar-${index}`} style={{ backgroundColor: color }} />
            ))}
      </div>
    </div>
    {!props.isApplicationView &&
      (props.isReportTRI ? (
        <div className="container-line">
          {props.avgByAreaMessage}
          <div className="line" style={{ backgroundColor: 'red' }} />
        </div>
      ) : (
        <div className="container-line">
          {props.TRILabel ? (
            <FormattedMessage {...messages.schoolAverage} />
          ) : props.isGradeGroupAvgView ? (
            <FormattedMessage {...messages.average} />
          ) : (
            <FormattedMessage {...messages.class} />
          )}
          <div className={`line ${props.isGradeGroupAvgView && 'red'}`} />
        </div>
      ))}
    {props.isAvgGeneral && (
      <div className="container-line">
        <FormattedMessage {...messages.generalAverage} />
        <div className="line" style={{ backgroundColor: 'black' }} />
      </div>
    )}
  </div>
);

Label.propTypes = {};

export default Label;
